var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "max-width": "700",
      "width": "100%"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    scopedSlots: _vm._u([{
      key: "extension",
      fn: function () {
        return [_c('v-tabs', {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        }, [_c('v-tabs-slider', {
          attrs: {
            "color": "secondary"
          }
        }), _c('v-tab', {
          key: "budget"
        }, [_vm._v(" Budget Vote ")]), _c('v-tab', {
          key: "finance"
        }, [_vm._v(" Finance ")]), _c('v-tab', {
          key: "policies"
        }, [_vm._v(" Policies ")])], 1)];
      },
      proxy: true
    }])
  }, [_c('v-toolbar-title', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v("Documents and Policies")])], 1), _c('v-card-text', {
    staticClass: "card-text primary--text font-weight-bold"
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('v-list', [_vm._l(_vm.budget, function (finance, k) {
    return [_c('v-list-item', {
      key: k,
      staticClass: "px-0"
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "primary--text text-body-1 font-weight-bold"
    }, [_vm._v(_vm._s(finance.text))])], 1), _c('v-list-item-action', {
      staticClass: "mr-0"
    }, [_c('v-btn', {
      attrs: {
        "color": "primary",
        "icon": "",
        "href": finance.url,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)], 1), _c('v-divider', {
      key: k + 'd'
    })];
  })], 2)], 1), _c('v-tab-item', [_c('v-list', [_vm._l(_vm.finances, function (finance, k) {
    return [_c('v-list-item', {
      key: k,
      staticClass: "px-0"
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "primary--text text-body-1 font-weight-bold"
    }, [_vm._v(_vm._s(finance.text))])], 1), _c('v-list-item-action', {
      staticClass: "mr-0"
    }, [_c('v-btn', {
      attrs: {
        "color": "primary",
        "icon": "",
        "href": finance.url,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)], 1), _c('v-divider', {
      key: k + 'd'
    })];
  })], 2)], 1), _c('v-tab-item', [_c('v-list', [_vm._l(_vm.policies, function (policy, k) {
    return [_c('v-list-item', {
      key: k,
      staticClass: "px-0"
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "primary--text text-body-1 font-weight-bold"
    }, [_vm._v(_vm._s(policy.text))])], 1), _c('v-list-item-action', {
      staticClass: "mr-0"
    }, [_c('v-btn', {
      attrs: {
        "color": "primary",
        "icon": "",
        "href": policy.url,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)], 1), _c('v-divider', {
      key: k + 'd'
    })];
  })], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }